<template>
    <div class="text-zinc-800 text-xs font-medium leading-[14px] h-7 pl-1.5 pr-2.5 py-1.5 bg-white rounded shadow border border-gray-200 justify-start items-center gap-1 inline-flex">
      <slot/>
    </div>
</template>
